import { BACKEND_URL } from "@/lib/api";

const loadImg = (src) => new Promise((resolve) => {
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.onload = () => resolve(img);
  img.onerror = () => resolve(null);
  img.src = src;
});

// Genera una imagen PNG de la alineación (campo + fotos + dorsales) y la comparte/descarga.
export async function sharePizarra({ state, byId, teamName, goalsBy = {}, yellowBy = {} }) {
  const W = 1080, HEAD = 190, FIELD_H = 1000, BENCH_H = state.bench.length ? 230 : 40, FOOT = 60;
  const H = HEAD + FIELD_H + BENCH_H + FOOT;
  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#0a0a0a"; ctx.fillRect(0, 0, W, H);
  ctx.textBaseline = "alphabetic";
  ctx.fillStyle = "#e11d2e"; ctx.font = "700 24px Arial"; ctx.textAlign = "left";
  ctx.fillText("ALINEACIÓN · SUDEFOOTBALL", 40, 54);
  const gf = state.events.filter((e) => e.type === "gol").length;
  const gc = state.events.filter((e) => e.type === "gol_contra").length;
  ctx.fillStyle = "#fff"; ctx.font = "900 50px Arial";
  let title = `${teamName} vs ${state.opponent}`.toUpperCase();
  if (title.length > 28) title = `${title.slice(0, 27)}…`;
  ctx.fillText(title, 40, 118);
  ctx.textAlign = "right"; ctx.font = "900 64px Arial";
  ctx.fillText(`${gf}-${gc}`, W - 40, 118);
  ctx.textAlign = "left"; ctx.fillStyle = "#9ca3af"; ctx.font = "24px Arial";
  ctx.fillText(`${state.modality} · ${state.homeAway === "casa" ? "En casa" : "Fuera"} · ${new Date().toLocaleDateString("es-ES")}`, 40, 160);

  const fy = HEAD;
  const grad = ctx.createLinearGradient(0, fy, 0, fy + FIELD_H);
  grad.addColorStop(0, "#14532d"); grad.addColorStop(1, "#166534");
  ctx.fillStyle = grad; ctx.fillRect(0, fy, W, FIELD_H);
  ctx.strokeStyle = "rgba(255,255,255,0.35)"; ctx.lineWidth = 3;
  ctx.strokeRect(30, fy + 30, W - 60, FIELD_H - 60);
  ctx.beginPath(); ctx.moveTo(30, fy + FIELD_H / 2); ctx.lineTo(W - 30, fy + FIELD_H / 2); ctx.stroke();
  ctx.beginPath(); ctx.arc(W / 2, fy + FIELD_H / 2, 110, 0, Math.PI * 2); ctx.stroke();
  ctx.strokeRect(W / 4, fy + 30, W / 2, 130);
  ctx.strokeRect(W / 4, fy + FIELD_H - 160, W / 2, 130);

  const ids = [...state.onField.map((f) => f.player_id), ...state.bench];
  const photos = {};
  await Promise.all(ids.map(async (pid) => {
    const p = byId[pid];
    if (p?.photo_url) photos[pid] = await loadImg(`${BACKEND_URL}${p.photo_url}`);
  }));

  const drawToken = (pid, cx, cy, r, color, withBadges = true) => {
    const p = byId[pid];
    ctx.save();
    ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.closePath();
    ctx.fillStyle = color; ctx.fill(); ctx.clip();
    if (photos[pid]) {
      ctx.drawImage(photos[pid], cx - r, cy - r, r * 2, r * 2);
    } else {
      ctx.fillStyle = "#fff"; ctx.font = `900 ${Math.round(r * 0.9)}px Arial`;
      ctx.textAlign = "center"; ctx.textBaseline = "middle";
      ctx.fillText(String(p?.jersey_number ?? "?"), cx, cy + 2);
    }
    ctx.restore();
    ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.strokeStyle = "#fff"; ctx.lineWidth = 4; ctx.stroke();
    if (photos[pid]) {
      const br = Math.max(16, r * 0.4);
      const bx = cx + r * 0.72, byy = cy + r * 0.72;
      ctx.beginPath(); ctx.arc(bx, byy, br, 0, Math.PI * 2);
      ctx.fillStyle = color; ctx.fill(); ctx.strokeStyle = "#fff"; ctx.lineWidth = 2.5; ctx.stroke();
      ctx.fillStyle = "#fff"; ctx.font = `900 ${Math.round(br)}px Arial`;
      ctx.textAlign = "center"; ctx.textBaseline = "middle";
      ctx.fillText(String(p?.jersey_number ?? "?"), bx, byy + 1);
    }
    const name = (p?.name || "?").split(" ")[0].toUpperCase();
    ctx.font = "700 22px Arial";
    const tw = ctx.measureText(name).width + 18;
    ctx.fillStyle = "rgba(0,0,0,0.78)";
    ctx.fillRect(cx - tw / 2, cy + r + 8, tw, 32);
    ctx.fillStyle = "#fff"; ctx.textAlign = "center"; ctx.textBaseline = "middle";
    ctx.fillText(name, cx, cy + r + 25);
    if (withBadges) {
      const badges = [];
      if (goalsBy[pid]) badges.push(`⚽${goalsBy[pid] > 1 ? "×" + goalsBy[pid] : ""}`);
      if (yellowBy[pid]) badges.push("🟨");
      if (badges.length) {
        ctx.font = "26px Arial";
        const btxt = badges.join(" ");
        const bw = ctx.measureText(btxt).width + 14;
        ctx.fillStyle = "rgba(0,0,0,0.78)";
        ctx.fillRect(cx - bw / 2, cy - r - 42, bw, 36);
        ctx.fillStyle = "#fff"; ctx.textBaseline = "middle";
        ctx.fillText(btxt, cx, cy - r - 23);
      }
    }
  };

  state.onField.forEach((f) => {
    const cx = 30 + ((W - 60) * f.x) / 100;
    const cy = fy + 30 + ((FIELD_H - 60) * f.y) / 100;
    drawToken(f.player_id, cx, cy, 56, f.player_id === state.gkId ? "#059669" : "#1d4ed8");
  });

  if (state.bench.length) {
    const by0 = HEAD + FIELD_H;
    ctx.fillStyle = "#111"; ctx.fillRect(0, by0, W, BENCH_H);
    ctx.fillStyle = "#9ca3af"; ctx.font = "700 22px Arial";
    ctx.textAlign = "left"; ctx.textBaseline = "alphabetic";
    ctx.fillText("BANQUILLO", 40, by0 + 46);
    state.bench.slice(0, 9).forEach((pid, i) => {
      drawToken(pid, 95 + i * 112, by0 + 130, 40, "#dc2626", false);
    });
  }

  ctx.fillStyle = "#6b7280"; ctx.font = "20px Arial";
  ctx.textAlign = "center"; ctx.textBaseline = "alphabetic";
  ctx.fillText("Creado con Sudefootball · sudefootball.sudeporte.com", W / 2, H - 22);

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
  const file = new File([blob], "alineacion.png", { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: "Alineación" });
      return "shared";
    } catch (e) {
      if (e.name === "AbortError") return "cancel";
    }
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `alineacion-${Date.now()}.png`;
  a.click();
  URL.revokeObjectURL(a.href);
  return "downloaded";
}
